import { render } from "./accueil-page.vue?vue&type=template&id=a8ed8bf0&scoped=true&ts=true"
import script from "./accueil-page.vue?vue&type=script&lang=ts"
export * from "./accueil-page.vue?vue&type=script&lang=ts"

import "./accueil-page.scss?vue&type=style&index=0&id=a8ed8bf0&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ed8bf0"]])

export default __exports__